var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22834 18.7088C6.9843 18.7088 5.16504 20.528 5.16504 22.7721C5.16504 25.0163 6.9843 26.8353 9.22834 26.8353C9.70328 26.8353 10.1591 26.7539 10.5828 26.6042",
    stroke: "#E87637",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52232 20.8822C3.70789 20.0066 2.45605 18.1494 2.45605 16C2.45605 14.3589 3.18566 12.8882 4.33833 11.8947",
    stroke: "#E87637",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38007 11.7853C4.02028 11.2475 3.81055 10.6008 3.81055 9.90511C3.81055 8.03509 5.32647 6.51904 7.19661 6.51904C7.95903 6.51904 8.66252 6.771 9.22858 7.19628",
    stroke: "#E87637",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54944 7.28481C9.34305 6.84702 9.22754 6.35798 9.22754 5.84181C9.22754 3.9718 10.7436 2.45587 12.6136 2.45587C14.4836 2.45587 15.9997 3.9718 15.9997 5.84181V26.8353",
    stroke: "#E87637",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.582 26.8353C10.582 28.3314 11.7947 29.5442 13.2909 29.5442C14.787 29.5442 15.9997 28.3314 15.9997 26.8353",
    stroke: "#E87637",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.22787C16 11.4719 17.8191 13.2912 20.0632 13.2912",
    stroke: "#E87637",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7723 18.7088C25.0165 18.7088 26.8356 20.528 26.8356 22.7721C26.8356 25.0163 25.0165 26.8353 22.7723 26.8353C22.2975 26.8353 21.8416 26.7539 21.418 26.6042",
    stroke: "#E87637",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4775 20.8822C28.292 20.0066 29.5438 18.1494 29.5438 16C29.5438 14.3589 28.8141 12.8882 27.6614 11.8947",
    stroke: "#E87637",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.62 11.7853C27.9797 11.2475 28.1895 10.6008 28.1895 9.90511C28.1895 8.03509 26.6735 6.51904 24.8034 6.51904C24.041 6.51904 23.3374 6.771 22.7715 7.19628",
    stroke: "#E87637",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.84181C16 3.9718 17.5159 2.45587 19.3861 2.45587C21.2562 2.45587 22.772 3.9718 22.772 5.84181C22.772 6.35798 22.6566 6.84702 22.4501 7.28481",
    stroke: "#E87637",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4177 26.8353C21.4177 28.3314 20.2049 29.5442 18.7088 29.5442C17.2127 29.5442 16 28.3314 16 26.8353",
    stroke: "#E87637",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/brain.3ba4d25d9efd239ed3d941e201ee0d28.svg";
export { ForwardRef as ReactComponent };